import { Link } from "react-router-dom";

const SIZES = {
  sm: { img: "h-9", word: "text-xl", sub: "text-[8px]" },
  md: { img: "h-11 md:h-12", word: "text-2xl md:text-3xl", sub: "text-[9px]" },
  lg: { img: "h-20", word: "text-4xl", sub: "text-[11px]" },
};

export const Logo = ({ light = false, size = "md", to = "/", className = "" }) => {
  const emblem = light ? "/anuswa-emblem-light.png" : "/anuswa-emblem.png";
  const wordColor = light ? "text-white" : "text-burgundy";
  const subColor = light ? "text-rose" : "text-muted-text";
  const s = SIZES[size] || SIZES.md;
  const inner = (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img src={emblem} alt="ANUSWA by Unique Cloth" className={`${s.img} w-auto`} />
      <div className="flex flex-col leading-none">
        <span className={`font-serif font-bold tracking-[0.18em] ${wordColor} ${s.word}`}>ANUSWA</span>
        <span className={`mt-1 tracking-[0.26em] ${subColor} ${s.sub} uppercase`}>by Unique Cloth · Palanpur</span>
      </div>
    </div>
  );
  return to ? <Link to={to} aria-label="ANUSWA home" data-testid="logo-link">{inner}</Link> : inner;
};

export default Logo;
